import React, { Component } from 'react';
import './Middle.css';
import Form from './Form';
import { v4 as uuid } from 'uuid';
import TasksList from './TasksList';

class Middle extends Component{
    constructor(props){
        super(props);
        this.state = {
            todos : [],
            filteredTodos : [],
            areFiltersActive : false
        }
        this.handleTask = this.handleTask.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCheckOut = this.handleCheckOut.bind(this);
        this.clearCompleted = this.clearCompleted.bind(this);
        this.filterAll = this.filterAll.bind(this);
        this.filterActive = this.filterActive.bind(this);
        this.filterCompleted = this.filterCompleted.bind(this);
    }
    filterAll(){
        this.setState({
            filteredTodos : [...this.state.todos],
            areFiltersActive : true 
        })
    }
    filterActive(){
        let activeTodos = []
        this.state.todos.forEach((eachTodo) => {
            if(!eachTodo.isCheckedOut){
                activeTodos.push(eachTodo);
            }
        })
        this.setState({
            filteredTodos : [...activeTodos],
            areFiltersActive : true 
        })
    }
    filterCompleted(){
        let completedTodos = [];
        this.state.todos.forEach((eachTodo) => {
            if(eachTodo.isCheckedOut){
                completedTodos.push(eachTodo)
            }
        })
        this.setState({
            filteredTodos : [...completedTodos],
            areFiltersActive : true
        })
    }
    clearCompleted(){
        this.setState({
            todos : [...this.state.todos.filter((eachTodo) => eachTodo.isCheckedOut !== true)],
            areFiltersActive : false 
        })
    }
    handleTask(obj){
        obj = {...obj, id : uuid()}
        this.setState((curState) => ({
            todos : [...curState.todos,obj],
        }))
        this.setState({areFiltersActive : false})
    }
    handleSave(currentTaskName,editedTaskName){
        this.state.todos.forEach((eachTodo) => {
            if(eachTodo.todo === currentTaskName){
                eachTodo.todo = editedTaskName;
            }
        })
        this.setState({
            todos : [...this.state.todos],
            areFiltersActive : false
        })
    }
    handleDelete(todoName){
        this.setState({
            todos : [...this.state.todos.filter((eachTodo) => eachTodo.todo !== todoName)],
            areFiltersActive : false
        })
    }
    handleCheckOut(currentTodoName,checkedOutStatus){
        this.state.todos.forEach((eachTodo) => {
            if(eachTodo.todo === currentTodoName){
                eachTodo.isCheckedOut = !checkedOutStatus;
            }
        })
        this.setState({
            todos : [...this.state.todos],
            areFiltersActive : false
        })
    }
    renderTodos(){
        return this.state.todos.map((eachTodo) => 
            <TasksList 
                handleSave = {this.handleSave}
                handleDelete = {this.handleDelete} 
                todo = {eachTodo.todo} key = {uuid()}
                checkedOutStatus = {eachTodo.isCheckedOut}
                todoObj = {eachTodo}
                handleCheckOut = {this.handleCheckOut}
                darkTheme = {this.props.darkTheme}
            />)
    }
    renderFilteredTodos(){
        return this.state.filteredTodos.map((eachTodo) =>
            <TasksList 
                handleSave = {this.handleSave}
                handleDelete = {this.handleDelete} 
                todo = {eachTodo.todo} key = {uuid()}
                checkedOutStatus = {eachTodo.isCheckedOut}
                todoObj = {eachTodo}
                handleCheckOut = {this.handleCheckOut}
                darkTheme = {this.props.darkTheme}
            />
        )
    }
    getLength(){
        let cnt = 0;
        this.state.todos.forEach((eachTodo) => {
            !eachTodo.isCheckedOut && cnt++;
        })
        return cnt;
    }
    render(){
        return(
            <div className = 'Tasks-Div'>
                <Form handleTask = {this.handleTask} darkTheme = {this.props.darkTheme}/>
                <div className = 'Tasks-Box'>
                    {
                        this.state.areFiltersActive ? 
                        this.renderFilteredTodos() : this.renderTodos()
                    }
                </div>
                <div className='Filters' style=
                {{backgroundColor : this.props.darkTheme ? 'hsl(235, 24%, 19%)' : '#fff'}}
                >
                    <p style = {{color : this.props.darkTheme ? 'white' : 'hsl(235, 19%, 35%)'}}>{this.getLength()} Items left</p>
                    <div>
                        <a  style = {{color : this.props.darkTheme ? 'white' : 'hsl(235, 19%, 35%)'}} href='/#' onClick = {this.filterAll}>All</a>
                        <a  style = {{color : this.props.darkTheme ? 'white' : 'hsl(235, 19%, 35%)'}} href = '/#' onClick = {this.filterActive}>Active</a>
                        <a  style = {{color : this.props.darkTheme ? 'white' : 'hsl(235, 19%, 35%)'}} href = "/#" onClick = {this.filterCompleted}>Completed</a>
                    </div>
                    <a  style = {{color : this.props.darkTheme ? 'white' : 'hsl(235, 19%, 35%)'}} href = "/#" onClick = {this.clearCompleted}>Clear Completed</a>
                </div>
            </div>
        )
    }
}

export default Middle;